import {
  all, call, put, takeEvery,
} from 'redux-saga/effects';
import { IRestApiResponse } from '../../interfaces';
import { request } from '../../utils/request';
import API from './constants';
import { GetReview } from './interface';
import { reviewAction } from './components/review-list/components/slice';

export function* getReviewListGenerator({ payload }:GetReview): any {
  try {
    const response: IRestApiResponse = yield call(
      request,
      {
        path: `${API.GET_REVIEWS.path}/?keyword=${payload.keyword}&page=${payload.page}&limit=${payload.limit}&sortBy=${payload.sortBy}`,
        method: API.GET_REVIEWS.method,
      },
      {},
      true,
      false,
    );
    if (response.statusCode === 200) {
      yield put(reviewAction.getReviewsSucceeded(response.data));
    } else {
      yield put(reviewAction.getReviewsFailed());
    }
  } catch (error) {
    yield put(reviewAction.getReviewsFailed());
  }
}

export function* reviewSaga() {
  yield all([
    takeEvery(
      reviewAction.getReviews.type,
      getReviewListGenerator,
    ),
  ]);
}

export const reviewSagas = {
  getReviewListGenerator,
};

export default reviewSaga;
